import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const t = i((l, o) => /* @__PURE__ */ e.jsx(
  s,
  {
    ref: o,
    ...l,
    image: (r) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M10.394.19c-.593.246-.998.52-1.413.96-.6.635-.99 1.53-.99 2.27v.329l.444-.035c.689-.053 1.262-.347 1.891-.968.762-.752 1.175-1.605 1.175-2.427V0l-.327.002c-.201 0-.5.073-.78.189m.158 3.612c-.2.034-.832.214-1.403.401l-1.039.34-1.143-.357c-1.085-.337-1.178-.355-1.831-.349-.555.006-.779.04-1.152.175-1.414.51-2.366 1.553-2.817 3.082-.21.709-.224 2.294-.03 3.165.429 1.924 1.588 4.02 2.834 5.122.58.514.81.606 1.495.606.5 0 .688-.037 1.396-.276.727-.245.89-.277 1.44-.277.544 0 .72.034 1.463.277 1.665.545 2.41.355 3.444-.879.477-.569.765-.973 1.091-1.53.242-.412.739-1.51.698-1.541-.012-.01-.19-.103-.397-.21-.55-.284-1.232-.969-1.508-1.514-.559-1.106-.506-2.485.132-3.448.206-.31.745-.839 1.126-1.102l.2-.139-.188-.237c-.403-.512-1.231-1-2.041-1.204-.524-.132-1.332-.18-1.77-.105",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
t.displayName = "AppleIcon";
export {
  t as AppleIcon,
  t as default
};
//# sourceMappingURL=index.js.map
